export const pluginId = 'color-picker';
